import React from 'react';
import Brick from './BrickCore';
import { Utils } from '../../services';
import { Field } from 'redux-form';
import { Col, FormGroup, Label } from 'reactstrap';

/** Class representing a workflow brick to
 * redirect the user
 */
class RedirectBrick extends Brick {
    /**
     * @returns {string|null}
     */
    getNodeDetails() {
        const url = this.getOption('url');
        if (url == null)
            return null;

        return this.truncateNodeDetail(url, 52);
    }

    /**
     * Get this brick options form
     *
     * @param {Object} props: an object with the following keys
     *                          - t
     *                          - workflow
     *                          - forms
     *                          - emails
     *                          - articles
     *                          - salepoints
     */
    getOptionsForm(props) {
        const { t } = props;
        return (
            <>
                <FormGroup row>
                    <Label for="form_id" className="text-v-center" sm={12}>
                        { t('workflows.bricks.redirect.options.url') }
                    </Label>
                    <Col sm={12}>
                        <Field component="input" type="text" name={`bricks[${this.position}].options.url`} className="form-control" />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label className="text-v-center" sm={12}>
                        { t('workflows.bricks.redirect.options.emit_redirect_to_parent') }
                    </Label>
                    <Col sm={12}>
                        <Field component="select" name={`bricks[${this.position}].options.emit_redirect_to_parent`} className="form-control">
                            <option value="true">{ t('common.yes') }</option>
                            <option value="false">{ t('common.no') }</option>
                        </Field>
                    </Col>
                </FormGroup>
            </>
        );
    }

    /**
     * Run this brick
     *
     * @param {Object} context
     * @param {Boolean} isEmbedded
     * @param {Callable} onDone
     */
    run(context, isEmbedded, onDone) {
        let url = this.getOption('url');
        let emit_redirect_to_parent = this.getOption('emit_redirect_to_parent');
        url = Utils.replaceShortcodes(url, context);
        if (emit_redirect_to_parent == null)
            emit_redirect_to_parent = true;
        else
            emit_redirect_to_parent = String(emit_redirect_to_parent).toLowerCase() !== 'false';

        onDone(context, (_err, _workflow) => {
            if (!isEmbedded) {
                window.location.href = url;
            } else {
                if (emit_redirect_to_parent) {
                    const message = {
                        type: '__tkt_workflow_message__',
                        action: 'redirect',
                        params: { url }
                    };
                    window.parent.postMessage(message, '*');
                } else {
                    window.location.href = url;
                }
            }
        });

        return null;
    }
}

export default RedirectBrick;
